import { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { RouteConstants } from "./RouteConstants";

import RequiredAuth from "components/common/RequiredAuth";
import Unauthorized from "components/common/Unauthorized";
import _404 from "components/common/_404";

// Use lazy loaded pages

const Login = lazy(() => import("modules/login/pages"));
const ForgotPassword = lazy(() => import("modules/forgotPassword/pages"));
const ResetPassword = lazy(() => import("modules/resetPassword/pages"));
const Ingredients = lazy(() => import("modules/ingredients/pages"));
const Recipes = lazy(() => import("modules/recipes/pages"));
const Tags = lazy(() => import("modules/category/pages/ShoppingAisles"));
const AddEditRecipe = lazy(() =>
  import("modules/recipes/components/AddEditRecipe/index")
);
const Challenges = lazy(() => import("modules/challenges/pages"));
const AddEditChallenges = lazy(() =>
  import("modules/challenges/components/AddEditChallenges")
);

const Products = lazy(() => import("modules/products/pages"));
const Featured = lazy(() => import("modules/featured/pages"));
const FullyFit = lazy(() => import("modules/fullyFit/pages"));


const AddEditProduct = lazy(() =>
  import("modules/products/components/AddEditProduct")
);

const PushNotifications = lazy(() => import("modules/pushNotifications/pages"));
const Users = lazy(() => import("modules/users/pages"));
const UserDetail = lazy(() => import("modules/users/components/UserDetail"));
const Faq = lazy(() => import("modules/faq/page"));
const Reports = lazy(() => import("modules/reports/pages"));
const Groups = lazy(() => import("modules/groups/pages"));
const FullCircle = lazy(() => import("modules/fullCircle/pages"));
const Admins = lazy(() => import("modules/admins/pages"));
const Dashboard = lazy(() => import("modules/dashboard/pages"));

const PromotionalOffer = lazy(() => import("modules/promotionalOffer/pages"));
const AddPromotionalOffer = lazy(() =>
  import("modules/promotionalOffer/components/addPromotionalOffer")
);

const Subscribers = lazy(() => import("modules/subscribers/pages"));
const ManageNotifications = lazy(() =>
  import("modules/manageNotifications/pages")
);

const routesConfig = {
  common: [
    {
      path: "unauthorized",
      component: Unauthorized,
    },
    {
      path: RouteConstants.manageNotifications,
      component: ManageNotifications,
    },
    { path: "*", component: _404 },
  ],
  private: [
    {
      path: "/",
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Dashboard />,
        },
      ],
    },
    {
      path: RouteConstants.dashboard,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Dashboard />,
        },
      ],
    },
    {
      path: RouteConstants.ingredients,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Ingredients />,
        },
      ],
    },
    {
      path: RouteConstants.recipes,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Recipes />,
        },
      ],
    },
    {
      path: RouteConstants.newRecipes,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <AddEditRecipe />,
        },
      ],
    },
    {
      path: RouteConstants.editRecipes,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <AddEditRecipe />,
        },
      ],
    },
    {
      path: RouteConstants.categories,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Tags />,
        },
      ],
    },
    {
      path: RouteConstants.challenges,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Challenges />,
        },
      ],
    },
    {
      path: RouteConstants.newChallenges,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <AddEditChallenges />,
        },
      ],
    },
    {
      path: RouteConstants.editChallenges,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <AddEditChallenges />,
        },
      ],
    },
    {
      path: RouteConstants.products,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Products />,
        },
      ],
    },
    {
      path: RouteConstants.addProduct,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <AddEditProduct />,
        },
      ],
    },
    {
      path: RouteConstants.editProduct,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <AddEditProduct />,
        },
      ],
    },
    {
      path: RouteConstants.featured,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Featured />,
        },
      ],
    },
    {
      path: RouteConstants.fullyFit,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <FullyFit />,
        },
      ],
    },
    // {
    //   path: RouteConstants.videos,
    //   component: RequiredAuth,
    //   children: [
    //     {
    //       index: true,
    //       component: () => <Videos />,
    //     },
    //   ],
    // },

    {
      path: RouteConstants.notifications,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <PushNotifications />,
        },
      ],
    },

    {
      path: RouteConstants.promotionalOffer,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <PromotionalOffer />,
        },
      ],
    },
    {
      path: RouteConstants.addPromotionalOffer,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <AddPromotionalOffer />,
        },
      ],
    },
    {
      path: RouteConstants.subscribers,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Subscribers />,
        },
      ],
    },
    {
      path: RouteConstants.editPromotionalOffer,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <AddPromotionalOffer />,
        },
      ],
    },

    {
      path: RouteConstants.users,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Users />,
        },
      ],
    },
    {
      path: RouteConstants.userDetail,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <UserDetail />,
        },
      ],
    },
    {
      path: RouteConstants.faq,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Faq />,
        },
      ],
    },
    {
      path: RouteConstants.reports,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Reports />,
        },
      ],
    },
    {
      path: RouteConstants.groups,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Groups />,
        },
      ],
    },
    {
      path: RouteConstants.fullCircle,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <FullCircle />,
        },
      ],
    },
    {
      path: RouteConstants.admins,
      component: RequiredAuth,
      children: [
        {
          index: true,
          component: () => <Admins />,
        },
      ],
    },
  ],
  public: [
    {
      path: RouteConstants?.login,
      component: Outlet,
      children: [{ index: true, component: () => <Login /> }],
    },
    {
      path: RouteConstants?.forgotPassword,
      component: Outlet,
      children: [{ index: true, component: () => <ForgotPassword /> }],
    },
    {
      path: RouteConstants?.resetPassword,
      component: Outlet,
      children: [{ index: true, component: () => <ResetPassword /> }],
    },
    {
      path: "*",
      component: () => <Navigate to={RouteConstants.dashboard} replace />,
    },
  ],
};

export default routesConfig;
